import { Link } from "react-router-dom";
import { CONTACT, SERVICES } from "../data";

const FOOTER_NAV = [
  { label: "Home", to: "/" },
  { label: "Wat is softwash?", to: "/softwash-methode" },
  { label: "Voor & na", to: "/#resultaten" },
  { label: "Over SoftPro", to: "/over-softpro" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => {
  return (
    <footer className="bg-navy-deep text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center">
              <img src="/logo-white.png" alt="SoftPro logo" className="h-11 w-auto" />
            </Link>
            <p className="mt-5 max-w-xs text-sm text-white/50 leading-relaxed">
              Specialist in Softwash gevelreiniging, dakreiniging en het
              reinigen van bedrijfspanden. Schoon, veilig en duurzaam.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white/40">
              Diensten
            </h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={s.path}
                    className="text-sm text-white/70 transition-colors hover:text-teal"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white/40">
              Navigatie
            </h4>
            <ul className="mt-5 space-y-3">
              {FOOTER_NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/70 transition-colors hover:text-teal"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white/40">
              Contact
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li>
                <a href={CONTACT.phoneHref} className="hover:text-teal">
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-teal">
                  {CONTACT.email}
                </a>
              </li>
              <li>Harskamp, Gelderland</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} SoftPro. Alle rechten voorbehouden.
          </p>
          <p className="text-xs text-white/40">
            Softwash · Lage druk · 100% biologisch afbreekbaar
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
